<template>
  <div class="relative swiperhomes">
    <swiper class="swiper" :options="swiperOptions">
      <!-- v-for="(item, index) in 6" :key="index" -->
      <!-- <swiper-slide class="">
        <div class="h-95per">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="absolute h-640px right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3 md:hidden lg:hidden block"
          >
            <img
              src="https://nexuscluster.blob.core.windows.net/server01/caregiversaathi/family/AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYy%20(1)%20(1).png"
              class="custborderradius h-250 w-full"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
              >
                Future fit corporate paying the way for a gender-inclusive
                workforce
              </p>
              <p
                class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
                @click="handleClick('Final-landing')"
              >
                Join us on this journey of transformation as we strive to build
                a Future Fit Organization.<br />
                <span
                  @click="handleClick('Final-landing')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >View</span
                >
              </p>
              <div>
                <span
                  @click="handleClick('Final-landing')"
                  class="underline text-4f0a4b min-hidden md-fsize14 font-semibold cursor-pointer"
                  >View</span
                >
                <div class="flex lg:pt-4 md:pt-4 mob-hidden">
                  <base-button
                    type="primary"
                    class="btntext"
                    @click="handleClick('Final-landing')"
                    >View</base-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
            <img
              src="https://nexuscluster.blob.core.windows.net/server01/caregiversaathi/family/AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYy%20(1)%20(1).png"
              class="custborderradius m-auto h-400 w-full"
              alt=""
            />
          </div>
        </div>
      </swiper-slide> -->

      <!-- <swiper-slide class="">
        <div class="h-95per">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="absolute h-640px right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3 md:hidden lg:hidden block"
          >
            <img
              src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Banner1.webp"
              class="custborderradius"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
              >
                We are all Caregivers!!
              </p>

              <p
                class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Help yourself as a caregiver.<br />
                Hire a Care Assistant.
              </p>
              <div>
                <span
                  @click="handleClick('serviceform')"
                  class="underline text-4f0a4b min-hidden md-fsize14 font-semibold cursor-pointer"
                  >Care assistant</span
                >
                <div class="flex lg:pt-4 md:pt-4 mob-hidden">
                  <base-button
                    type="primary"
                    class="btntext"
                    @click="handleClick('serviceform')"
                    >Care assistant</base-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
            <img
              src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Banner1.webp"
              class="custborderradius m-auto"
              alt=""
            />
          </div>
        </div>
      </swiper-slide> -->

      <!-- <swiper-slide class="">
        <div>
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="absolute h-640px right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3 md:hidden lg:hidden block"
          >
            <img
              src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Banner2.webp"
              class="custborderradius lg:hidden md:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
              >
                Become a Caregiver Coach
              </p>
              <p
                class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
                @click="handleClick('coach')"
              >
                Caregiving journeys are an emotional roller coaster with very
                personal goals. Caregiver coaching is different given the
                emotional challenges of the caregiver. If you are a certified
                coach, you can specialise as a Caregiver coach.

                <span
                  @click="handleClick('coach')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Know more</span
                >
              </p>
              <div
                class="flex lg:pt-8 md:pt-8 mob-hidden"
                @click="handleClick('coach')"
              >
                <base-button type="primary" class="btntext"
                  >Know more</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Banner2.webp"
              class="custborderradius m-auto"
              alt=""
            />
          </div>
        </div>
      </swiper-slide> -->

      <!-- <swiper-slide class="">
        <div class="h-95per">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="absolute h-640px bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <div class="lg:w-1/2 md:w-1/2 lg:mt-0 md:mt-0 mt-3 w-full">
            <img
              src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Banner3.webp"
              class="custborderradius m-auto md:block lg:block hidden"
              alt=""
            />
            <img
              src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Banner3.webp"
              class="md:hidden custborderradius lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
              >
                We UNDERSTAND Caregivers and Caregiving…You are NOT alone
              </p>
              <p
                class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Explore ways to become more effective and prevent your burnout.
                <span
                  @click.stop="handleClick('caregiver')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Know more</span
                >
              </p>

              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="btntext"
                  @click="handleClick('caregiver')"
                  >Know more</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </swiper-slide> -->

      <!-- <swiper-slide class="">
        <div class="h-95per">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="absolute h-640px right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3 md:hidden lg:hidden block"
          >
            <img
              src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Banner4.webp"
              class="custborderradius"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
              >
                Need HELP to support a Caregiver?
              </p>
              <p
                class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
                @click="handleClick('wellwisher')"
              >
                Your sister or your wife is the primary caregiver. You want to
                help but don’t know how.<br />
                Learn what you can do to help a caregiver you love - gift them a
                service!

                <span
                  @click="handleClick('wellwisher')"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >Know more</span
                >
              </p>
              <div
                class="flex lg:pt-8 md:pt-8 mob-hidden"
                @click="handleClick('wellwisher')"
              >
                <base-button type="primary" class="btntext"
                  >Know more</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
            <img
              src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Banner4.webp"
              class="custborderradius m-auto"
              alt=""
            />
          </div>
        </div>
      </swiper-slide> -->

      <swiper-slide
        class=""
        v-for="(item, index) in getAllBanner.result"
        :key="index"
      >
        <div class="h-75per">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="bg-white h-500px"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3">
            <!-- src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Banner5.webp" -->
            <img
              :src="`${$imageURL}/${item.image}`"
              class="custborderradius m-auto md:block lg:block hidden h-330px"
              alt=""
            />
            <!-- src="https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/CG/homepage/Banner5.webp" -->
            <img
              :src="`${$imageURL}/${item.image}`"
              class="md:hidden custborderradius lg:hidden block sm-h-240px w-full"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize20 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
              >
                <!-- Professional Caregiving is STRESSFUL -->
                {{ item.heading }}
              </p>
              <p
                class="fsize25 md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px md-lh-32px sm-lh20"
              >
                <!-- It is challenging to maintain the ability to provide
                professional care continuously – Your well-being matters too. -->
                {{ item.content }}

                <span
                  @click="handleClick(item.link)"
                  class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                  >{{ item.btnName }}</span
                >
              </p>
              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="btntext"
                  @click="handleClick(item.link)"
                  >{{ item.btnName }}</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <div
        class="swiper-button-prev swiper-button-prevs"
        slot="button-prev"
      ></div>
      <div
        class="swiper-button-next swiper-button-nexts"
        slot="button-next"
      ></div>

      <!-- <div
        class="swiper-pagination swiper-pagination1 cust-posi dot-shift top97"
        slot="pagination"
        max-length="5"
      ></div> -->
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
          clickable: true,
          el: ".swiper-pagination1",
        },
        // autoplay: {
        //   delay: 12000,
        //   disableOnInteraction: false,
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      isLogedIn: false,
      editModal: false,
    };
  },

  methods: {
    handleClick(name) {
      if (name.includes("http")) {
        window.open(name, "_blank");
      } else {
        this.$router.push({ name: name });
      }
    },
  },
  computed: {
    ...mapState("homePageBanner", { getAllBanner: "getAllBanner" }),
  },
  async mounted() {
    try {
      await this.$store.dispatch("homePageBanner/getAll");
    } catch (error) {
      console.log(error);
    }
    if (sessionStorage.getItem("token")) {
      this.isLogedIn = true;
    } else {
      this.isLogedIn = false;
    }
    this.$emit("cover-loaded");
  },
};
</script>
<style scoped>
@media (min-width: 1024px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.9);
    filter: hue-rotate(40deg);
  }

  .swiper-button-next {
    right: 25px !important;
  }

  .swiper-button-prev {
    left: 25px !important;
  }
}
@media (max-width: 640px) {
  .sm-w-94 {
    width: 90%;
  }
  .homeswiper.swiper-button-next,
  .homeswiper.swiper-button-prev {
    transform: scale(0.5);
    filter: hue-rotate(40deg);
  }
  .sm-h-banner {
    height: 210px;
    margin-top: 2rem;
    margin-left: 4rem;
  }
  .top97 {
    top: 97% !important;
  }
}
</style>
